import { Button, Header, Icon, Modal } from '@mairistem/composants';

interface ModalEncaisseDepasseeProps {
  encaisseGlobaleDepassee?: boolean;
  encaisseNumeraireDepassee?: boolean;
  onClose: () => void;
}

const ModalEncaisseDepassee = (props: ModalEncaisseDepasseeProps) => {
  const { encaisseGlobaleDepassee, encaisseNumeraireDepassee, onClose } = props;

  return (
    <Modal open size="tiny" onClose={onClose}>
      <Modal.Header>
        <Icon name="warning sign" style={{ fontSize: '1.25em' }} />
        Encaisse dépassée
      </Modal.Header>
      <Modal.Content>
        {encaisseGlobaleDepassee && encaisseNumeraireDepassee ? (
          <>
            Vous ne pouvez pas encaisser cette facture, vos encaisses globale et numéraire vont être
            dépassées.
            <Header as="h4">
              <Header.Content>
                <br />
                Vous devez effectuer un versement des fonds que vous détenez.
              </Header.Content>
            </Header>
          </>
        ) : encaisseGlobaleDepassee ? (
          <>
            Vous ne pouvez pas encaisser cette facture, votre encaisse globale va être dépassée.
            <Header as="h4">
              <Header.Content>
                <br />
                Vous devez effectuer un versement des fonds que vous détenez.
              </Header.Content>
            </Header>
          </>
        ) : encaisseNumeraireDepassee ? (
          <>
            Vous ne pouvez pas encaisser cette facture en numéraire, votre encaisse en numéraire va
            être dépassée.
            <Header as="h4">
              <Header.Content>
                <br />
                Vous devez effectuer un versement des fonds que vous détenez.
              </Header.Content>
            </Header>
          </>
        ) : null}
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="button-close-encaisse-depassee"
          onClick={onClose}
          basic
          content="Fermer"
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalEncaisseDepassee;
